import { Box, Stat, StatGroup } from "@chakra-ui/react";
import { useTransactions } from "../context/TransactionsContext";
import { formatEuro } from "../utils/helperFunctions";
import { useCurrentMonth } from "../hooks/useCurrentMonth";

export const Summary = () => {
  const { transactions } = useTransactions();
  const currentMonth = useCurrentMonth();

  const filteredTransactions = transactions.filter((t) => {
    const date = new Date(t.date);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    return `${year}-${month}` === currentMonth;
  });

  const income = filteredTransactions
    .filter((t) => t.type === "income")
    .reduce((a, b) => a + b.amount, 0);
  const expense = filteredTransactions
    .filter((t) => t.type === "expense")
    .reduce((a, b) => a + b.amount, 0);
  const balance = income - expense;

  return (
    <Box bg={"gray.100"} borderRadius="md" pr={2}>
      <StatGroup pt={8} pb={8}>
        <Stat.Root pr={4} pl={{ base: 6 }}>
          <Stat.Label>Einnahmen</Stat.Label>
          <Stat.ValueText whiteSpace={"nowrap"} color="green.600">
            {"+"}
            {formatEuro(income)}
          </Stat.ValueText>
        </Stat.Root>
        <Stat.Root pr={4} pl={{ base: 5, md: 0, lg: 0 }}>
          <Stat.Label>Ausgaben</Stat.Label>
          <Stat.ValueText whiteSpace={"nowrap"} color="red.500">
            {"-"}
            {formatEuro(expense)}
          </Stat.ValueText>
        </Stat.Root>
        <Stat.Root pr={4} pl={{ base: 6, md: 2, lg: 2 }}>
          <Stat.Label>Saldo</Stat.Label>
          <Stat.ValueText whiteSpace={"nowrap"}>
            {formatEuro(balance)}
          </Stat.ValueText>
        </Stat.Root>
      </StatGroup>
    </Box>
  );
};
